import React from 'react';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import {
    SlideContainer, SlideTitle, SlideText, BulletList, BulletItem, HighlightBox, IconCircle,
    welcomeSlide, historicSlide, finalSlide,
} from 'components/v3/onboarding/OnboardingSlideElements';

// ==========================================
// Profil STORE — store-manager
// Atterrissage : /store-manager. Voit Mon magasin + Historique + Paramètres.
// ==========================================

export const storeSlides = () => [
    welcomeSlide(
        "Votre espace s'articule autour de « Mon magasin », une vue avec les informations essentielles liées à votre magasin, et de « Historique », qui garde la trace de tous les scans.",
    ),

    {
        title: '1 · Mon magasin',
        content: (
            <SlideContainer>
                <SlideTitle>
                    <IconCircle><StorefrontOutlinedIcon /></IconCircle>
                    1 · Mon magasin
                </SlideTitle>
                <SlideText>
                    Votre page d'accueil. Le nom du magasin s'affiche en haut ; si vous en gérez plusieurs, un{' '}
                    <strong>sélecteur</strong> permet de passer de l'un à l'autre.
                </SlideText>

                <BulletList>
                    <BulletItem>
                        <strong>Aujourd'hui</strong> — le bandeau du haut affiche le nombre d'<strong>emballages vides en stock</strong>{' '}
                        dans votre magasin. Le compteur
                        « retraits/mises en rayon » arrivera avec la connexion aux transporteurs ; en attendant il
                        affiche « donnée non disponible dans votre configuration ».
                    </BulletItem>
                    <BulletItem>
                        <strong>Master Contenant</strong> — c'est la jauge de votre bac de collecte (si vous en utilisez un), avec le pourcentage de
                        remplissage et le nombre de places restantes. Quand elle approche du plein, c'est le moment de
                        préparer l'enlèvement.
                    </BulletItem>
                    <BulletItem>
                        <strong>Vides à retourner</strong> — les emballages vides stockés qui attendent le retour du transporteur.
                    </BulletItem>
                    <BulletItem>
                        <strong>Pleins</strong> — les emballages pleins avec la commande client. Cette données n'est pas disponible pour le moment sans connexion avec le transporteur.
                    </BulletItem>
                </BulletList>

                <HighlightBox>
                    <SlideText sx={{ marginBottom: 0 }}>
                        ✏️ La capacité du Master Contenant est un réglage : si votre bac n'a pas la même contenance
                        que celle affichée, demandez à votre administrateur de l'ajuster.
                    </SlideText>
                </HighlightBox>
            </SlideContainer>
        ),
    },

    historicSlide(2, false),
    finalSlide(),
];
